import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import AddForms from "../../../../components/sections/admin/forms/AddForms";

const Forms = () => {
  const [forms, setForms] = useState([
    {
      fieldType: "TextArea",
      label: "",
      placeholder: "",
      isRequired: false,
    },
  ]);

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    const reordered = Array.from(forms);
    const [removed] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, removed);

    setForms(reordered);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="formFields">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="space-y-4"
          >
            {forms?.map((form, i) => (
              <AddForms
                key={i}
                form={form}
                id={form?._id || i}
                index={i}
                copyHandler={(val, id) =>
                  setForms((pre) => {
                    const findIndex = pre.findIndex((item, index) =>
                      item?._id ? item?._id === id : index === id
                    );

                    if (findIndex !== -1) {
                      const newArray = [...pre];
                      newArray.splice(findIndex + 1, 0, val);
                      pre = newArray;
                    }
                    return [...pre];
                  })
                }
                onSave={(val) => {
                  setForms((pre) =>
                    pre.map((item, index) => (index === i ? val : item))
                  );
                }}
                onRemove={(id) =>
                  setForms((pre) =>
                    pre.filter((item, index) =>
                      item?._id ? item._id !== id : index !== id
                    )
                  )
                }
                removeable={forms.length > 1}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Forms;
